import { LikertIntroExampleCard, ScenarioIntroExampleCard } from "./IntroExampleCard";

/** Dev-only pagina voor scripts/capture-intro-examples.mjs */
export function IntroCapturePage() {
  return (
    <div className="bloom-intro-capture">
      <div id="intro-example-likert">
        <LikertIntroExampleCard />
      </div>
      <div id="intro-example-scenario">
        <ScenarioIntroExampleCard />
      </div>
    </div>
  );
}
